import Toast from "./toast";

export default Toast;